import {Component, EventEmitter, Output} from '@angular/core';
import {BrowserService} from "@services/components/browser.service";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-close-button',
  standalone: true,
  imports: [
    NgClass
  ],
  template: `
    <button (click)="closeButton.emit()" [ngClass]="{tablet_class: isTablet}" class="close_btn br_50 pointer flex_center_align_center" >
      <img  src="assets/images/icons/close_icon.svg">
    </button>
  `,
  styles: [`
    .close_btn {
      position: absolute;
      right: 0;
      top: 0;
      width: 32px;
      height: 32px;
      background-color:var(--white-color);
      border: none;
      outline: none;
    }

    .tablet_class {
      background-color: #F6F7F8 !important;
      right: 16px !important;
      top: 16px !important;
      z-index: 9;
    }
  `]
})
export class CloseButtonComponent {
  @Output() closeButton = new EventEmitter<any>();
  isTablet = false;
  constructor(
    private browserService: BrowserService,
  ) {
    this.isTablet = this.browserService.isTabletDevice;
  }
}
